export default __webpack_public_path__ + "static/media/no-races.282e74cb.png";